module.exports = __webpack_public_path__ + "static/media/ellipse.tablet.413661e9.png";